var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSports(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 34 34",
    style: {
      enableBackground: "new 0 0 34 34"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#6F109E;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_57082",
    transform: "translate(-45 -755)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "running",
    transform: "translate(55 742.675)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57084",
    transform: "translate(0.826 24.581)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57083",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9833",
    className: "st0",
    d: "M-1.2-4.7h-4.2c-0.5,0-0.8,0.4-0.8,0.8C-6.3-3.4-5.9-3-5.4-3h4.2c0.5,0,0.8-0.4,0.8-0.8 C-0.4-4.3-0.8-4.7-1.2-4.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_57086",
    transform: "translate(0.826 27.886)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57085",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9834",
    className: "st0",
    d: "M-1.2-1.4h-4.2c-0.5,0-0.8,0.4-0.8,0.8c0,0.5,0.4,0.8,0.8,0.8h4.2c0.5,0,0.8-0.4,0.8-0.8 C-0.4-1-0.8-1.4-1.2-1.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_57088",
    transform: "translate(0 26.234)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57087",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9835",
    className: "st0",
    d: "M-2.1-3h-4.2c-0.5,0-0.8,0.4-0.8,0.8c0,0.5,0.4,0.8,0.8,0.8h4.2c0.5,0,0.8-0.4,0.8-0.8 C-1.2-2.7-1.6-3-2.1-3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_57090",
    transform: "translate(5.399 25.82)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57089",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9836",
    className: "st0",
    d: "M14.1,1.5h-5v-3.3c0-0.9-0.8-1.7-1.7-1.7C7-3.4,6.6-3.3,6.3-3l-6.6,6.6C-1,4.3-1,5.4-0.3,6 c0,0,0,0,0,0l3.8,3.8l-4.6,4.6c-0.6,0.6-0.6,1.7,0,2.3c0.6,0.6,1.7,0.6,2.3,0L7,11c0.6-0.6,0.6-1.7,0-2.3c0,0,0,0,0,0L3.2,4.8 l2.6-2.6v1c0,0.9,0.7,1.7,1.7,1.7l0,0h6.7c0.9,0,1.7-0.7,1.7-1.7S15.1,1.5,14.1,1.5L14.1,1.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_57092",
    transform: "translate(4.16 23.961)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57091",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9837",
    className: "st0",
    d: "M4.2-5C3.6-5.5,2.7-5.4,2.1-4.8l-4.6,4.6c-0.6,0.6-0.6,1.7,0,2.3s1.7,0.6,2.3,0l3.6-3.6 l1.2,0.9l1.6-1.6c0.3-0.3,0.6-0.5,0.9-0.6L4.2-5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_57094",
    transform: "translate(0.441 30.375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57093",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9838",
    className: "st0",
    d: "M3.4,2.6C3,2.2,2.7,1.7,2.6,1.1l-8.8,8.8c-0.6,0.6-0.6,1.7,0,2.3c0.6,0.6,1.7,0.6,2.3,0 l8.4-8.4L3.4,2.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_57096",
    transform: "translate(9.685 23.164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57095",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_559",
    className: "st0",
    cx: 6.4,
    cy: -4.8,
    r: 3
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSports);
export default __webpack_public_path__ + "static/media/sports.e1c18cdb398467e0aa808e2bf1b29a7b.svg";
export { ForwardRef as ReactComponent };